/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_ClaimantInputs */

const en_case_section_claimant = /** @type {(inputs: Case_Section_ClaimantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claimant`)
};

const pt_br2_case_section_claimant = /** @type {(inputs: Case_Section_ClaimantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requerente`)
};

/**
* | output |
* | --- |
* | "Claimant" |
*
* @param {Case_Section_ClaimantInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_claimant = /** @type {((inputs?: Case_Section_ClaimantInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_ClaimantInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_claimant(inputs)
	return pt_br2_case_section_claimant(inputs)
});